import React, { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import Card from "../components/ui/Card";

const sampleChartData = [
  { name: "Jan", Sales: 4000, Expenses: 2400 },
  { name: "Feb", Sales: 3000, Expenses: 2210 },
  { name: "Mar", Sales: 5000, Expenses: 2290 },
  { name: "Apr", Sales: 2780, Expenses: 2000 },
  { name: "May", Sales: 1890, Expenses: 2181 },
  { name: "Jun", Sales: 2390, Expenses: 2500 },
];

const Charts = () => {
  const [hiddenBars, setHiddenBars] = useState({ Sales: false, Expenses: false });

  const toggleBar = (key) => {
    setHiddenBars((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Interactive Chart</h1>
      <Card>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={sampleChartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend
              onClick={(e) => toggleBar(e.value)}
              wrapperStyle={{ cursor: "pointer" }}
            />
            {!hiddenBars.Sales && <Bar dataKey="Sales" fill="#82ca9d" />}
            {!hiddenBars.Expenses && <Bar dataKey="Expenses" fill="#8884d8" />}
          </BarChart>
        </ResponsiveContainer>
      </Card>
    </div>
  );
};

export default Charts;
